import NibDivider from '@nib-components/divider';

export const Divider = (): JSX.Element => <NibDivider />;
